/** @jsxRuntime classic */
/** @jsx jsx */
import { css, jsx } from "@emotion/react";
import { SquareLoader } from "components/atoms/loader/SquareLoader";
import React from "react";

import type { FcWithoutChildren } from "types/fcWithoutChildren";

export const CentrallyLocatedLoader: FcWithoutChildren = () => (
  <div aria-busy="true" css={rootStyle} role="status">
    <SquareLoader />
    <span css={screenReaderStyle}>Loading</span>
  </div>
);

const rootStyle = css`
  display: grid;
  place-content: center;
  padding: 56px;
  width: 100%;
`;

// Bootstrap、Tailwind、Chakra UI 等で採用されてる screen reader 向けの隠しテキスト用スタイル
const screenReaderStyle = css`
  border: 0;
  clip: rect(0, 0, 0, 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  white-space: nowrap;
  width: 1px;
`;
